import { EMPTY, ERROR, READY } from '@blueberry/constants/loadingState';
export const types = {
  FETCH_SUBJECT_PAGE: 'FETCH_SUBJECT_PAGE',
  FETCH_SUBJECT_PAGE_SUCCESS: 'FETCH_SUBJECT_PAGE_SUCCESS',
  FETCH_SUBJECT_PAGE_FAILURE: 'FETCH_SUBJECT_PAGE_FAILURE',
};

export const fetchSubjectPageSuccess = ({ curriculum, subject, subtopic }) => ({
  type: types.FETCH_SUBJECT_PAGE_SUCCESS,
  payload: {
    curriculum,
    subject,
    subtopic,
  },
});
export const fetchSubjectPageFailure = err => ({
  type: types.FETCH_SUBJECT_PAGE_FAILURE,
  payload: {
    err,
  },
});

const initialState = {
  status: EMPTY,
  curriculum: {},
  subject: {},
  subtopic: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SUBJECT_PAGE_SUCCESS:
      return {
        ...state,
        status: READY,
        curriculum: action.payload.curriculum,
        subject: action.payload.subject,
        subtopic: action.payload.subtopic,
      };
    case types.FETCH_SUBJECT_PAGE_FAILURE:
      return {
        ...state,
        status: ERROR,
      };
    default:
      return state;
  }
};

export default reducer;

export const getCurriculum = state => state.subjectPage.curriculum;
export const getSubject = state => state.subjectPage.subject;
export const getSubtopic = state => state.subjectPage.subtopic;
export const getStatus = state => state.subjectPage.status;



// WEBPACK FOOTER //
// ./app/redux/subjectPage.js